import React from "react";
import MPBossEmployee from "./BossEmployeeComps/MPBossEmployee";

export default function BossEmployee() {
  return (
    <div className="flex-1 h-full">
      <MPBossEmployee />
    </div>
  );
}
